<template>
  <Modal
    hide-close-button
    :title="title"
  >
    <QCard class="q-pa-sm">
      <span> Account Managers: </span>
      <QCardSection class="row justify-center">
        <span>
          {{ accountManagers }}
        </span>
      </QCardSection>
    </QCard>

    <QCard class="q-mt-sm q-pa-sm">
      <span> Contacts: </span>
      <QCardSection class="row justify-center">
        <span>
          {{ emails }}
        </span>
      </QCardSection>
    </QCard>

    <template #buttons="{ close }">
      <QBtn
        class="q-ma-sm"
        label="Copy contacts to clipboard"
        @click="copyContactsToClipboard()"
      />
      <QBtn
        class="q-ma-sm"
        label="Okay"
        @click.prevent="close"
      />
    </template>
  </Modal>
</template>

<script>
import Modal from "shared/components/core/modals/Modal.vue";
import useClipboard from "shared/composables/useClipboard";

export default {
  name: "OrganisationReportSpecsContactsModal",
  components: {
    Modal,
  },
  props: {
    organisationReportSpec: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const { copyToClipboard } = useClipboard();

    return { copyToClipboard };
  },
  computed: {
    title() {
      return (
        this.organisationReportSpec.subject || this.organisationReportSpec.title
      );
    },
    emails() {
      return this.organisationReportSpec.contact_emails.split(",").join(", ");
    },
    accountManagers() {
      return this.organisationReportSpec.organisation.account_manager.name;
    },
  },
  methods: {
    copyContactsToClipboard() {
      this.copyToClipboard(this.emails);
    },
  },
};
</script>

<style lang="scss" scoped>
.streem-dialog {
  background-color: rgb(255 255 255);
}
</style>
